import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword, resetForgotPasswordState } from "../../redux/reducer/authReducer";
import CustomTitleWihBox from "../sharedComponents/customTitleWithBox";
import CustomInput from "./CustomInput";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
export default function ForgotPasswordForm() {
  const [email, setEmail] = useState("");
  // const [lang, setLang] = useState("en");
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const { loading, success, error } = useSelector((state) => state.auth);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(forgotPassword({ email }));
  };

  useEffect(() => {
    // Reset state when component unmounts
    return () => {
      dispatch(resetForgotPasswordState());
    };
  }, [dispatch]);
  const direction = useLanguageDirection();

  return (
    <div
      className="block shadow-lg rounded-lg bg-white p-8 mx-auto md:w-2/3 max-w-[700px] " dir={direction}

    >
      <CustomTitleWihBox title={t("ForgotPassword")}/>
      <form onSubmit={handleSubmit}>
        {/* Email Input */}
        <div className="mt-4 mb-6">
          <CustomInput
            id="email"
            type="email"
            placeholder={t("EnterYourEmail")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            icon={<EnvelopeIcon />}
            required
          />
        </div>

        {/* Submit Button */}
        <div className="flex justify-center mb-6">
          <button
            type="submit"
            className="block w-full px-6 py-2 font-medium text-black uppercase transition duration-150 ease-in-out rounded-lg shadow-lg lg:text-lg lg:py-3 bg-custom-yellow hover:bg-primary-600 focus:outline-none"
            disabled={loading} // Disable button while loading
          >
    {loading ? t("Sending") : t("Send")}      
     </button>
        </div>

        {/* Success or Error Message */}
        {success && (
        <p className="text-center text-green-600">
          {t("EmailSentSuccess")}
        </p>
      )}
        {error && <p className="text-center text-red-600">{t("UserEmailNotExist")}</p>}
      </form>
    </div>
  );
}
